/* eslint-disable prettier/prettier */
import { Button } from '@mui/material'
import { Box } from '@mui/system'
import styled from 'styled-components'
import { RADIUS, SHADOW, SURFACE } from '../../theme/tokens'

export const LoginContainer = styled(Box)`
    width: 100vw;
    min-height: 100vh;
    background: ${SURFACE.page};
`

export const LoginButtonContainer = styled(Box)`
    position: absolute;
    height: 250px;
    width: 400px;
    border: 1px solid ${SURFACE.border};
    border-radius: ${RADIUS.lg}px;
    background: ${SURFACE.card};
    box-shadow: ${SHADOW.card};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
`

export const StyledGoogleButton = styled(Button)`
    padding: 10px !important;
    width: 300px;
    margin: 0 auto !important;
`

export const BhanzuLogo = styled.img`
    width: 200px;
    margin: 0 auto;
    margin-bottom: 10px;
`
